import styled from 'styled-components/macro';
import { device } from 'components/styles/MediaQuery';
import { hexToRGB } from '@repo-level/core-front';

export const ScWithdrawModal = styled.div`
  font-family: ${({ theme }) => theme.mainFontFamily};
  position: relative;
  background: ${({ theme }) => theme.secondaryColor3};
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  max-width: 768px;
  margin: 40px auto;
  @media (${device.mobile}) {
    margin: 16px auto;
  }
`;

export const ScWithdrawTitle = styled.div`
  padding: 16px;
  font-weight: bold;
  font-size: 32px;
  line-height: 40px;
  text-transform: uppercase;
  border-bottom: ${({ theme }) => `1px solid ${theme.secondaryColor3}`};
`;

export const ScWithdrawRow = styled.div`
  display: grid;
  grid-template-columns: 330px auto;
  @media (${device.mobile}) {
    display: block;
  }
`;

export const ScWithdrawNav = styled.div`
  padding: 16px;
  border-right: ${({ theme }) => `1px solid ${theme.secondaryColor3}`};
  @media (${device.mobile}) {
    border-right: none;
    border-bottom: ${({ theme }) => `1px solid ${theme.secondaryColor3}`};
  }
`;

export const ScWithdrawContent = styled.div`
  position: relative;
  padding: 16px;

  word-break: break-word;

  .deposit-value {
    display: flex;
    font-size: 16px;
    line-height: 1.5;
  }

  .amount-wrapper {
    display: flex;
    font-size: 16px;
    align-items: center;
    margin-top: 8px;
  }

  .withdraw-button {
    button {
      margin-top: 16px;
    }
  }
`;

export const ScCurrencyUser = styled.div`
  border-bottom: ${({ theme }) => `1px solid ${theme.secondaryColor3}`};
  padding: 16px;
  margin: -16px -16px 0 -16px;
  button {
    min-width: unset !important;
  }
  .selector + button {
    height: 36px;
    @media (${device.mobile}) {
      height: 48px;
    }
  }
  h3 {
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 16px;
  }
  .row {
    display: flex;

    & > .selector,
    & > button {
      width: 50%;
    }

    & > .selector {
      margin-right: 4px;
    }
    & > button {
      margin-left: 4px;
    }
  }
`;

export const ScPaymentsMethods = styled.div`
  padding: 16px;
  margin: 0 -16px 0 -16px;
  @media (${device.mobile}) {
    padding-bottom: 0;
  }
  h3 {
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 16px;
  }
  .payments {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
    @media (${device.mobile}) {
      gap: 8px;
    }
    button {
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      border-radius: 4px;
      background: ${({ theme }) => hexToRGB(theme.whiteColor, 0.3)};
      border: ${({ theme }) =>
        `1px solid ${hexToRGB(theme.secondaryColor, 0.5)}`};
      cursor: pointer;
      height: 40px;
      transition: 0.3s;
      &:hover {
        border: ${({ theme }) => `2px solid ${hexToRGB(theme.mainColor, 0.6)}`};
      }
      &.active {
        border: ${({ theme }) => `2px solid ${hexToRGB(theme.mainColor, 1)}`};
      }
      img {
        height: 28px;
        max-width: 80%;
        object-fit: contain;
      }
    }
  }
`;

export const ScNotFound = styled.div`
  padding: 16px 24px;
  border: 1px solid transparent;
  border-radius: 8px;

  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
`;

export const ScWithdrawForm = styled.div``;
